<template>
  <b-button
    class="passenger-selection-row m-0 p-0 font-size-16px"
    variant="ghost"
    @click="
      () => {
        if (onClick) onClick();
      }
    "
    v-b-hover="handleHover"
  >
    <span v-if="is_infant(passenger)" class="d-flex" v-html="svg_infant('#6c757d', 17)"></span>
    <span v-else class="thin">P{{ passenger.id }}</span>
    <span
      :class="
        'text-nowrap font-size-16px ' +
        (isHovered ? 'text-primary' : '') +
        (selected ? 'text-primary bold' : '')
      "
      >{{ formatPassengerName(passenger) }}</span
    >
    <span class="overflow-hidden truncate-text-overflow passenger-selection-grow">
      <span class="thin">
        <span v-if="is_infant(passenger)" class="text-nowrap">NEONATO</span>
        <span v-else-if="is_child(passenger)" class="text-nowrap">BAMBINO</span>
        <span v-if="passenger.holding" class="text-nowrap bold">con bebè</span>
      </span>
    </span>
    <span v-if="seat" class="text-primary bold passenger-selection-row-seat">{{
      seat.number
    }}</span>
    <span v-else-if="is_infant(passenger)" class="text-primary bold passenger-selection-row-seat"
      >Neonato in braccio</span
    >
    <span v-else-if="emptyNotSelected"></span>
    <span v-else class="text-gray bold passenger-selection-row-seat">Scelta della compagnia</span>
  </b-button>
</template>

<script>
import { formatPassengerName, is_infant, is_child } from '@/utilities';
import { infant } from '@/components/svg/user';

export default {
  name: 'passenger-selection-row',
  props: {
    passenger: Object,
    seat: Object,
    emptyNotSelected: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    onClick: Function,
  },
  data() {
    return {
      formatPassengerName,
      isHovered: false,
    };
  },
  methods: {
    is_infant,
    is_child,
    svg_infant: infant,
    handleHover() {
      if (this.onClick) {
        this.isHovered = !this.selected && !this.isHovered;
      }
    },
  },
};
</script>

<style class="scss">
.passenger-selection-row {
  display: flex;
  gap: 10px;

  .passenger-selection-grow {
    text-align: start;
    flex-grow: 1;
  }

  .passenger-selection-row-seat {
    text-align: end;
  }

  span:last-of-type {
    margin-left: auto;
  }
}
</style>
